import { graphql, useStaticQuery } from "gatsby";
import { Category } from "../../constants/categories.constants";
import { Hashtag } from "../../constants/hashtags.constants";
import { Sector } from "../../constants/sectors.constants";
import { ImageWithMetaInfo, ProjectMetaInfo, ProjectMetaInfoWithQueriedResources } from "../../types/app.types";
import { MjHudsonBridgeImagesQuery } from "../../types/generated";

export const ProjectMetaInfoMJHudsonBridge: ProjectMetaInfo = {
  name: "mjhudson-bridge",
  displayName: "MJ Hudson: Bridge Consulting",
  abbreviation: "Bridge Consulting",
  subtitle: "Irish Specialist Financial Consulting Firm",
  description: "Bridge Consulting, a well renowned specialist in financial services consultation and compliance, entrusted with the task of a comprehensive overhaul of the company’s brand; updating their online platform and creating a distinct and engaging website specifically tailored to their brand goals. It has recently joined MJ Hudson, a global asset management consultancy.",
  url: 'https://bridgeconsulting.ie/',
  categories: [
    Category.websites,
  ],
  sectors: [
    Sector.finance,
  ],
  hasPage: false,
  hashtags: [
    Hashtag.branding,
    Hashtag.digitalDesign,
    Hashtag.printDesign,
  ],
  keywords: [
    'branding design',
    'web design',
    'print design',
    'WordPress',
    'financial consulting company',
  ],
}
export const useMJHudsonBridgeInfo = () => {
  const MJHudsonBridgeImages: MjHudsonBridgeImagesQuery = useStaticQuery(graphql`
    query MJHudsonBridgeImages {
      featuredImage: file(relativePath: {eq: "images/mjhudson-bridge/samuel-beckett-bridge-in-twilight-river-liffey-dublin.jpg"}) {
        childImageSharp {
          gatsbyImageData(width: 1280, height: 720)
        }
      }
      gallery: allFile(
        sort: {fields: name},
        filter: {
          extension: {regex: "/(jpg)|(jpeg)|(png)/"},
          relativeDirectory: {eq: "images/mjhudson-bridge/gallery"}
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 2560, height: 1440)
            }
          }
        }
      }
    }`
  )
  const imageMetaData: Partial<ImageWithMetaInfo>[] = [
    {
      title: "Bridge Consulting Homepage Screenshot",
      alt: "Bridge Consulting Homepage Screenshot, desktop version",
    },
  ]
  const info: ProjectMetaInfoWithQueriedResources = {
    ...ProjectMetaInfoMJHudsonBridge,
    featuredImage: {
      image: MJHudsonBridgeImages.featuredImage!.childImageSharp,
      title: 'MJ Hudson – Bridge Consulting',
      alt: 'Samuel Beckett Bridge in twilight, River Liffey, Dublin'
    },
    gallery: MJHudsonBridgeImages.gallery.edges.map((edge, i) => ({
      image: edge.node.childImageSharp?.gatsbyImageData,
      ...imageMetaData[i]
    }))
  }
  return info;
}